module.exports = __webpack_public_path__ + "static/challenge.9cdd0b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartUp/img/challenge.png
// module id = 823
// module chunks = 110243015079028